// extracted by mini-css-extract-plugin
export default {"root":"CalendarStrip_root__FqHeC"};